<mat-card class="cardWithShadow">
    <mat-card-content>
    <mat-card-title>Deudores - Lista Negra</mat-card-title>
  
      <div class="spinner">
        <mat-spinner [diameter]="60" *ngIf="booleanFlag == true"></mat-spinner>
        <h3 *ngIf="booleanText == false">No Existen Deudores</h3>
      </div>
      
      <div class="table-responsive m-t-30" [class.esconder]="dataSource.data.length==0 || booleanFlag==true">
        <table mat-table [dataSource]="dataSource" class="w-100" matSort
        (matSortChange)="changeSortingTable($event)">
  
          <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
              Nombre
            </th>
            <td mat-cell *matCellDef="let element" (click)="dealDialogOpen(element.companyId)" 
            style="text-decoration: underline; color: blue; cursor: pointer">
              <h6>
                {{ element.name }}
              </h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="rut">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
              Rut
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>
                {{ element.rut }}
              </h6>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row [cdkContextMenuTriggerFor]="menu" class="cursor-table" *matRowDef="let row; columns: displayedColumns">
            <ng-template #menu>
              <div cdkMenu class="context_menu mat-elevation-z8">
                <button
                  class="context-menu-item"
                  cdkMenuItem
                  mat-raised-button
                  style="background-color: #3f51b5; color: white"
                  (click)="openDialogConfirm(row.rut)"
                >
                  Quitar de la lista
                </button>
              </div>
            </ng-template>
          </tr>
  
        </table>
        <mat-paginator (page)="changePaginationTable($event)" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  
      </div>
    </mat-card-content>
</mat-card>